import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { ActivityCodeApi, ActivityCodeDataType, } from "@/api/ActivityCodeApi";
import { showAlert } from "@utils/Alert";
import { useAdminContext } from "@/hooks/useAdminContext";

const ActivityCodesIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ActivityCodeApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Actividada Economica no puedo ser eliminado');
    } else {
      showAlert('success', 'La Actividada Economica fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const fetchData = (...args: any[]) =>
    isAdminMode
      ? ActivityCodeApi.fetchAllByOwnerId(adminTenantId!)
      : ActivityCodeApi.fetchAll(...args);

  return (
    <PageContainer
      title=" Actividadas Economicas"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/economy-activity${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ActivityCodeDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "code",
            filterType: "eq",
            type: "number"
          },
          {
            key: "title",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "code",
          },
          {
            key: "title"
          },
          {
            key: "default",
            optionalHighlighted: (val: any) => { return val == "true" },
            highlightedText: "Predeterminada",
            nonHighlightedText: "No Predeterminada"
          },
          {
            key: "activo",
            optionalHighlighted: (val: any) => { return val == "true" },
            highlightedColors: {
              "false": {
                "bg": "#dc3545",
                "text": "#fff"
              },
              "true": {
                "bg": "#9cd47d",
                "text": "#fff"
              }
            },
            highlightedText: "Activa",
            nonHighlightedText: "Inactiva"
          }
        ]}
        listActions={[
          {
            href: `/user/economy-activity/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Actividada Economica",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Actividada Economica",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Actividada Economica",
              confirmMessage: "¿Seguro que desea eliminar esta Actividada Economica?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ActivityCodesIndex;
